import React, { useEffect } from "react";
import { Card, Drawer, Layout, Space, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useMediaQuery } from "react-responsive";

import { Util } from "../../util/Util";
import clsx from "clsx";
import FullScreenLoader from "./FullScreenLoader";
import Sidebar from "../sidebar/Sidebar";
import { getMenus } from "../../redux/menu/menuSlice";
import PageHeader from "../header/PageHeader";
const util = new Util();

const { Header, Content, Footer, Sider } = Layout;

const GlobalLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [isInvalid, setIsInvalid] = useState(true);
  const [isLoading, setIsLoading] = useState(true); // Track loading state
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const menus = useSelector((state) => state.auth.menus);
  const isMediumScreen = useMediaQuery({ maxWidth: 1023 });

  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState("left");

  // useEffect(() => {
  //   const isinv = util.invalidUser();
  //   setIsInvalid(isinv);
  //   // Set loading state to false once authentication status is determined
  //   setIsLoading(false);
  // }, [isAuthenticated]);
  useEffect(() => {
    const isinv = util.invalidUser();
    setIsInvalid(isinv);
    // Set loading state to false once authentication status is determined
    setIsLoading(false);
    if (isinv) {
      //return <Navigate to="/login" replace={true} />;
      navigate("/login");
    }
  }, [isAuthenticated]);
// Render login page if not authenticated
// useEffect(() => {
//   if (isInvalid) {
//     console.log('isInvalid:', isInvalid)
//     //return <Navigate to="/login" replace={true} />;
//     navigate("/login");
//   }
// }, [isInvalid])
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setCollapsed(isMediumScreen);
  }, [isMediumScreen]);

  useEffect(() => {
    const handleResize = () => {
      setCollapsed(isMediumScreen);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMediumScreen]);

  const toggleSider = () => {
    setCollapsed(!collapsed);
  };

  // Render loading spinner while authentication status is being determined
  if (isLoading) {
    return <FullScreenLoader />;
  }


  // Render main content if authenticated
  return (
    <Layout>
      {!isInvalid && (
        <div>
          {isMediumScreen ? (
            <Drawer
              style={{ width: 280, height: "calc(100vh)" }}
              bodyStyle={{ padding: 0, overflowX: "hidden", overflowY: "auto" }}
              headerStyle={{ padding: 5 }}
              placement={placement}
              width={280}
              onClose={onClose}
              open={open}
            >
              <Sidebar
                defaultOpenKeys={[]}
                collapsed={collapsed}
                isMediumScreen={isMediumScreen}
                menus={menus}
              />
            </Drawer>
          ) : (
            <Sider
              // className="fixed bottom-0 left-0 top-0"
              width={280}
              collapsible
              collapsed={collapsed}
              collapsedWidth={0}
              // trigger={null}
              style={{
                overflow: "auto",
                height: "100vh",
                position: "sticky",
                top: 0,
                left: 0,
                overflowX: "hidden",
                overflowY: "auto",
              }}
            >
              <Sidebar
                defaultOpenKeys={[]}
                collapsed={collapsed}
                isMediumScreen={isMediumScreen}
                menus={menus}
              />
            </Sider>
          )}
        </div>
      )}
      <Layout>
      {!isInvalid && (<Card
          className={clsx(
            "rounded-none fixed top-0 right-0  shadow-sm z-[999]",
            !collapsed ? " left-[280px]" : " left-0"
          )}
          bodyStyle={{ padding: "0 12px 0 0", height: 60 }}
        >
          <PageHeader
            toggleSider={toggleSider}
            collapsed={collapsed}
            isMediumScreen={isMediumScreen}
            showDrawer={showDrawer}
          />
        </Card>)}
        <Content 
        // style={{ margin: "70px 8px 0", overflow: "auto" }}
        className={!isInvalid ? 'mt-[70px]':''}
        >
          <div 
          // style={{ textAlign: "center" }} 
          className={!isInvalid ? 'p-2':''}
          >
            <Outlet />
          </div>
        </Content>
        <Footer style={{ textAlign: "center", fontWeight:'bold', fontSize:'16px' }}>
          &copy; {new Date().getFullYear()} | Softshore
        </Footer>
      </Layout>
    </Layout>
  );
};

export default GlobalLayout;
